import React from "react";
// import sideimage from "../assets/sideimage.png";
import Display from "./display/Display";
import Header from "./header/Header";
import "./Main.css";
const Main = () => {
  return (
    <div className="main-container mt-4">
      {/* <img src={sideimage} alt="" className="main-image" /> */}
      <Header />
      <Display />
    </div>
  );
};

export default Main;
